import type { WavespeedSpeechModelConfig } from '../types';

export const elevenlabsConfigs: Record<string, WavespeedSpeechModelConfig> = {
  'elevenlabs-eleven-v3': {
    // https://wavespeed.ai/zh-CN/models/elevenlabs/eleven-v3
    apiPath: '/elevenlabs/eleven-v3',
    enableTranslation: false,
    buildInput: ({ text, voice, providerOptions }) => {
      return {
        text: text,
        voice_id: voice,
        // 可选参数
        similarity: typeof providerOptions?.similarity === 'number' ? providerOptions.similarity : 1,
        stability: typeof providerOptions?.stability === 'number' ? providerOptions.stability : 0.5,
        use_speaker_boost:
          typeof providerOptions?.use_speaker_boost === 'boolean'
            ? providerOptions.use_speaker_boost
            : true,
      };
    },
  },
  'elevenlabs-music': {
    // https://wavespeed.ai/zh-CN/models/elevenlabs/music
    apiPath: '/elevenlabs/music',
    enableTranslation: false,
    buildInput: ({ text, voice, providerOptions }) => {
      return {
        prompt: `${text}\n[Lyrics]\n${providerOptions?.lyrics || ''}`,
        music_length_ms: providerOptions?.duration_seconds ? providerOptions.duration_seconds * 1000 : 40000,
        force_instrumental: voice === 'Music Mode' ? false : true,
        // 可选参数
        output_format:
          typeof providerOptions?.output_format === 'string'
            ? providerOptions.output_format
            : 'mp3_standard',
      };
    },
  },
  'elevenlabs-voice-changer': {
    // https://wavespeed.ai/zh-CN/models/elevenlabs/voice-changer
    apiPath: '/elevenlabs/voice-changer',
    enableTranslation: false,
    buildInput: ({ voice, audioUrls, providerOptions }) => {
      return {
        // 音频 URL
        audio: audioUrls?.[0],
        voice_id: voice,
        // 可选参数
        remove_background_noise:
          typeof providerOptions?.remove_background_noise === 'boolean'
            ? providerOptions.remove_background_noise
            : false,
      };
    },
  },
};